import moment from '@g4/moment-utc';
import { find } from 'lodash';
import Router from 'next/router';
import Cookies from 'universal-cookie';

import { MODE_START, MODE_END } from '../components/Boneyard/DateRangePicker';
import { getUrlSearchParams } from '../components/withQueryParams';

export const addOneMonthTo = date =>
  date
    .clone()
    .startOf('month')
    .add(1, 'month');

export const subtractOneMonthTo = date =>
  date
    .clone()
    .startOf('month')
    .subtract(1, 'month');

export const genMonthRestrictions = (start, mode) => {
  const startDate = mode === MODE_END ? start.clone().add(1, 'day') : moment();
  const endDate =
    start && mode === MODE_END
      ? start.clone().add(30, 'day')
      : moment().add(12, 'month');
  const range = startDate.twix(endDate);
  const iter = range.iterate('days');
  const restrictions = [];
  while (iter.hasNext()) {
    restrictions.push(iter.next().format('YYYY-MM-DD'));
  }
  return {
    start: restrictions,
    end: restrictions,
  };
};

export const getCurrentRestrictions = mode => {
  const restrictions = genMonthRestrictions();
  if (mode === MODE_START) {
    return restrictions.start || [];
  } else if (mode === MODE_END) {
    return restrictions.end || [];
  }
};

export const calcFirstCalendarScope = (mode, start, end) => {
  let scope = moment().clone();
  const bounds = getCurrentRestrictions(mode);
  const firstAvailableDate = moment(bounds[0]);
  if (scope.isBefore(firstAvailableDate, 'month')) {
    scope = firstAvailableDate;
  }
  if (start && end && mode === MODE_END && !start.isSame(end, 'month')) {
    scope = subtractOneMonthTo(end);
  } else if (start) {
    scope = start.clone();
  }
  return scope;
};

export const calcSingleCalendarScope = (mode, start, end) => {
  let scope = moment().clone();
  const bounds = getCurrentRestrictions(mode);
  const firstAvailableDate = moment(bounds[0]);
  if (scope.isBefore(firstAvailableDate, 'month')) {
    scope = firstAvailableDate;
  }
  if (mode === MODE_END) {
    if (end) {
      scope = end.clone();
    } else if (start) {
      scope = start.clone();
    }
  } else if (mode === MODE_START && start) {
    scope = start.clone();
  }

  return scope;
};

export const calcSecondCalendarScope = (mode, start, end) => {
  if (start && end && mode === MODE_END && !start.isSame(end, 'month')) {
    return end;
  }
  if (start) {
    return addOneMonthTo(start);
  }
  return addOneMonthTo(moment());
};

// use fixed-point notation
export const formatPrice = price => `$${parseFloat(price, 10).toFixed(2)}`;

export const adultsCount = rooms => {
  let totalCount = 0;

  rooms.forEach(room => {
    totalCount += room.adults;
  });
  return totalCount;
};

export const childrenCount = rooms => {
  let totalCount = 0;

  rooms.forEach(room => {
    if (room.childrenAges) {
      totalCount += room.childrenAges.length;
    }
  });
  return totalCount;
};

export const guestsCount = rooms => {
  return adultsCount(rooms) + childrenCount(rooms);
};

export const detectCardPartial = (cardNumberInput, rankOrderedCardTypes) => {
  if (cardNumberInput) {
    // It is possible that more than one card matches `regexMin`.
    // In such cases, return the first one encountered.
    return rankOrderedCardTypes.find(card => {
      var accountNumber = find(card.fields, { name: 'accountNumber' });
      return (
        accountNumber.regexMin && accountNumber.regexMin.test(cardNumberInput)
      );
    });
  }
};

export const generateAnalyticsData = () => {
  const cookies = new Cookies(document && document.cookie);
  const searchManifest = 'transaction-id';

  let results = getUrlSearchParams(Router);
  let { rooms } = results.hotelSearchCriteria;

  let adults = rooms && adultsCount(rooms);
  let children = rooms && childrenCount(rooms);
  let guests = rooms && guestsCount(rooms);

  let { locationCode, from, to } = Router.query;

  let updateDataLayerVariables = {
    hotel_destination: locationCode,
    hotel_check_in_date: from,
    hotel_check_out_date: to,
    hotel_number_of_rooms: Router.query.rooms?.length,
    hotel_number_of_adults: adults,
    hotel_number_of_children: children,
    hotel_total_number_of_guests: guests,
    hotel_total_guests: guests,
    hotel_total_number_of_rooms: rooms?.length,
    search_manifest: cookies.cookies[searchManifest],
    hotel_id: results.hotelId ? results.hotelId : '',
  };

  return updateDataLayerVariables;
};
